import { render, staticRenderFns } from "./banjiSj.vue?vue&type=template&id=0cb9ba9f&scoped=true"
import script from "./banjiSj.vue?vue&type=script&lang=js"
export * from "./banjiSj.vue?vue&type=script&lang=js"
import style0 from "./banjiSj.vue?vue&type=style&index=0&id=0cb9ba9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb9ba9f",
  null
  
)

export default component.exports